import { Injectable } from '@angular/core';
import { Storage } from "@ionic/storage";

@Injectable()

export class NotificationService {

  public data:any = [];

  constructor(
    public storage: Storage
  ) {
    this.load();
  }

  public addNotification(body, sent){
    let record = {
      list_title: body,
      list_subtitle: 'Verstuurd op ' + sent
    };
    this.data.unshift(record);
    this.save();
  }

  public deleteNotification(record){
    for(let i = 0; i < this.data.length; i++){
      if(this.data[i] === record){
        this.data.splice(i, 1);
      }
    }
    this.save();
  }

  public load(){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('notifications_' + user_id).then((val) => {
          this.data = (val ? JSON.parse(val) : []);
          resolve();
        }).catch(() => {
          this.data = [];
          resolve();
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public save(){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.set('notifications_' + user_id, JSON.stringify(this.data)).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/notification.service.ts